// Shared "are we running against dummy/local data instead of a real API" check.
//
// Several files (PlanFeaturesContext, results.jsx, browseBy.jsx, searchBar.jsx) each had
// their own slightly-different inline version of this check — some via
// `import.meta.env.DEV && window.location.hostname === 'localhost'` (which requires a
// production Vite build to have DEV=false, but would still be true for a `vite preview`
// or misconfigured local prod-mode server), others via a bare hostname/port check with no
// import.meta.env.DEV guard at all (results.jsx). Centralizing this avoids that drift and
// makes the "local dev = use hardcoded dummy data" behavior consistent across every call
// site instead of each one silently deciding differently.
export const isLocalDevMode = () => {
  if (typeof window === 'undefined') return false;
  const { hostname, port } = window.location;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    port === '5173'
  );
};
